import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { productionOrderDetailsJobsConfig } from './config';

const ProductionOrderDetailsJobStack = createStackNavigator();

const ProductionOrderDetailsProductionOrderNavigator = () => {
  return (
    <ProductionOrderDetailsJobStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {productionOrderDetailsJobsConfig.map(({ Component, name }) => (
        <ProductionOrderDetailsJobStack.Screen key={name} name={name} component={Component} />
      ))}
    </ProductionOrderDetailsJobStack.Navigator>
  );
};

export { ProductionOrderDetailsProductionOrderNavigator };
